import { render } from "./NewProductDetail.vue?vue&type=template&id=e0790ce6&scoped=true"
import script from "./NewProductDetail.vue?vue&type=script&lang=js"
export * from "./NewProductDetail.vue?vue&type=script&lang=js"

import "./NewProductDetail.vue?vue&type=style&index=0&id=e0790ce6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0790ce6"]])

export default __exports__